import {Injectable} from '@angular/core';
import {Result} from "@domain/common/http/result";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {MotInterdit} from "@domain/admin/parametre/authentification/mot-interdit";

/**
 * Service des appels de la liste noire
 *
 * @author Lionel Gimenez
 * @date 28/08/2025
 */
@Injectable({
    providedIn: "root",
})
export class ListeNoireHttpService {
    /**
     * Constructeur
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Sauvegarde la liste noire
     */
    save(motDePasse: string,fichier?: File): Observable<Result> {
        //Création du FormData
        const formData = new FormData();

        //Ajout du mot de passe si renseigné
        if (motDePasse) {
            const passwordBlackList = {
                mot: motDePasse
            };
            formData.append('mot',new Blob([JSON.stringify(passwordBlackList)],{type: 'application/json'}));
        }

        //Ajout du fichier si renseigné
        if (fichier) {
            formData.append('file',fichier);
        }

        //Envoi de la requête
        return this.http.post<Result>('/controller/AuthAdmin/saveBlackList',formData);
    }

    /**
     * Suppression des mots interdits
     */
    delete(listeMotInterdit: MotInterdit[]): Observable<Result> {
        return this.http.post<Result>(`/controller/AuthAdmin/deleteBlackList`,listeMotInterdit);
    }
}